/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo, useState } from 'react'
import { notification } from 'antd'

import { RequestLoginModal } from 'features/Race/components'
import { useToggle } from 'hooks'
import GuildVaultStyled from './styled'
import Button from 'shared/Button'
import { LINE_GUILD_GRADIENT } from 'assets/images'
import TableCoin from './components/TableCoin'
import DonateCoinModals from './components/Modals/DonateCoin'
import DonateNftModals from './components/Modals/DonateNft'
import DonateNonNftModals from './components/Modals/DonateNonNft'
import DonateTicketModals from './components/Modals/DonateTicket'
import TableNft from './components/TableNft'
import TableNonNft from './components/TableNonNft'
import TableTicket from './components/TableTicket'
import Select from 'shared/Select'

const GUILD_VAULT_TABS = {
  COIN: 'COIN',
  NFT: 'NFT',
  NON_NFT: 'NON-NFT',
  NFT_TICKET: 'NFT TICKET'
}

const defaultFilterTypeNft = [
  {
    name: 'All',
    isActive: true
  },
  {
    name: 'HEAD',
    isActive: false
  },
  {
    name: 'BODY',
    isActive: false
  },
  {
    name: 'LEG',
    isActive: false
  },
  {
    name: 'SKIN',
    isActive: false
  },
]

const defaultFilterTypeNonNft = [
  {
    name: 'All',
    isActive: true
  },
  {
    name: 'ENERGY',
    isActive: false
  },
  {
    name: 'DOPING ',
    isActive: false
  },
]

const defaultFilterRarityNft = [
  {
    name: 'All',
    isActive: true
  },
  {
    name: 'COMMON',
    isActive: false
  },
  {
    name: 'RARE',
    isActive: false
  },
  {
    name: 'EPIC',
    isActive: false
  },
  {
    name: 'LEGENDARY',
    isActive: false
  },
  {
    name: 'MYTHIC',
    isActive: false
  },
]

export default function GuildVault() {
  const [, contextHolder] = notification.useNotification()
  const [isRequestLoginModalOpen, toggleIsRequestLoginModalOpen] = useToggle(false)
  const [tabActive, setTabActive] = useState<string>(GUILD_VAULT_TABS.NFT)
  const [isModalDonateCoin, setIsModalDonateCoin] = useToggle(false)
  const [isModalDonateNft, setIsModalDonateNft] = useToggle(false)
  const [isModalDonateNonNft, setIsModalDonateNonNft] = useToggle(false)
  const [isModalDonateTicket, setIsModalDonateTicket] = useToggle(false)
  const [filterTypeNft, setFilterTypeNft] = useState<string>('Type')
  const [filterRarityNft, setFilterRarityNft] = useState<string>('Rarity')
  const [filterTypeNonNft, setFilterTypeNonNft] = useState<string>('Type')
  const dataTabsList = useMemo(() => {
    return [
      {
        id: 1,
        title: 'NFT',
        isActive: tabActive === GUILD_VAULT_TABS.NFT,
        component: <TableNft filters={{filterTypeNft, filterRarityNft}} />,
        type: GUILD_VAULT_TABS.NFT
      },
      {
        id: 2,
        title: 'NFT TICKET',
        isActive: tabActive === GUILD_VAULT_TABS.NFT_TICKET,
        component: <TableTicket />,
        type: GUILD_VAULT_TABS.NFT_TICKET
      },
      {
        id: 3,
        title: 'NON-NFT',
        isActive: tabActive === GUILD_VAULT_TABS.NON_NFT,
        component: <TableNonNft filters={{filterTypeNonNft}} />,
        type: GUILD_VAULT_TABS.NON_NFT
      },
      {
        id: 4,
        title: 'COIN',
        isActive: tabActive === GUILD_VAULT_TABS.COIN,
        component: <TableCoin />,
        type: GUILD_VAULT_TABS.COIN
      },
    ]
  }, [tabActive, filterTypeNft, filterRarityNft, filterTypeNonNft])

  const handleDonate = (isValue = true) => {
    switch (tabActive) {
      case GUILD_VAULT_TABS.COIN:
        setIsModalDonateCoin(isValue)
        return null
      case GUILD_VAULT_TABS.NFT:
        setIsModalDonateNft(isValue)
        return null
      case GUILD_VAULT_TABS.NON_NFT:
        setIsModalDonateNonNft(isValue)
        return null
      case GUILD_VAULT_TABS.NFT_TICKET:
        setIsModalDonateTicket(isValue)
        return null
      default:
        return null
    }
  }

  const handleCloseModal = () => {
    handleDonate(false)
  }

  const handleConfirmDonate = () => {
    switch (tabActive) {
      case GUILD_VAULT_TABS.COIN:
        setIsModalDonateCoin(false)
        return null
      case GUILD_VAULT_TABS.NFT:
        setIsModalDonateNft(false)
        return null
      case GUILD_VAULT_TABS.NON_NFT:
        setIsModalDonateNonNft(false)
        return null
      case GUILD_VAULT_TABS.NFT_TICKET:
        setIsModalDonateTicket(false)
        return null
      default:
        return null
    }
  }

  return (
    <GuildVaultStyled>
      {contextHolder}
      <div className='guild-vault'>
        <div className='tab-container'>
          <div className='tabs-button'>
            {dataTabsList.map(tabButton => (
              <Button
                classNames={!tabButton.isActive ? 'btn-enabled' : ''}
                key={tabButton.id}
                buttonName={tabButton.title}
                onClickButton={() => setTabActive(tabButton.type)}
                width={tabButton.isActive ? 152 : 147}
                height={tabButton.isActive ? 52 : 45}
                type={tabButton.isActive ? '' : 'btnSelectAll'}
              />
            ))}
          </div>
          <div className='d-flex'>
            {
              tabActive === GUILD_VAULT_TABS.NFT && (
                <>
                  <Select
                    dataSelect={defaultFilterTypeNft}
                    nameSelect={filterTypeNft}
                    onSelected={(value: any) => setFilterTypeNft(value)}
                  />
                  <Select
                    dataSelect={defaultFilterRarityNft}
                    nameSelect={filterRarityNft}
                    onSelected={(value: any) => setFilterRarityNft(value)}
                  />
                </>
              )
            }
            {
              tabActive === GUILD_VAULT_TABS.NON_NFT && (
                <Select
                  dataSelect={defaultFilterTypeNonNft}
                  nameSelect={filterTypeNonNft}
                  onSelected={(value: any) => setFilterTypeNonNft(value)}
                />
              )
            }
            <Button buttonName='Donate' onClickButton={handleDonate} width={147} />
          </div>
        </div>
        <div className='row line__guild--gradiant'>
          <img src={LINE_GUILD_GRADIENT} />
        </div>
        <div className='tab-content'>{dataTabsList.find(tabContent => tabContent.isActive)?.component}</div>
      </div>

      {isRequestLoginModalOpen && <RequestLoginModal toggleIsModalOpen={toggleIsRequestLoginModalOpen} />}
      {isModalDonateCoin && (
        <DonateCoinModals
          onCloseButtonClick={handleCloseModal}
          onConfirmDonate={handleConfirmDonate}
          toggleIsModalOpen={setIsModalDonateCoin}
        />
      )}
      {isModalDonateNft && (
        <DonateNftModals
          onCloseButtonClick={handleCloseModal}
          onConfirmDonate={handleConfirmDonate}
          toggleIsModalOpen={setIsModalDonateNft}
        />
      )}
      {isModalDonateNonNft && (
        <DonateNonNftModals
          onCloseButtonClick={handleCloseModal}
          onConfirmDonate={handleConfirmDonate}
          toggleIsModalOpen={setIsModalDonateNft}
        />
      )}
      {isModalDonateTicket && (
        <DonateTicketModals
          onCloseButtonClick={handleCloseModal}
          onConfirmDonate={handleConfirmDonate}
          toggleIsModalOpen={setIsModalDonateNft}
        />
      )}
    </GuildVaultStyled>
  )
}
